module.exports = __webpack_public_path__ + "static/media/MALAYSIA-circle.ff6584da.svg";